import script from "./AIResumeUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AIResumeUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./AIResumeUploadModal.vue?vue&type=style&index=0&id=ec919378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec919378"]])

export default __exports__